import { SwitchWithLabel } from "@/components/form/SwitchWithLabels";
import { Collapse } from "antd";
import { useTranslation } from "react-i18next";
import type { SeveritiesAdvancedInputSettings } from "../types";
interface SeveritiesAdvancedSettingsProps {
  data: SeveritiesAdvancedInputSettings;
  setData: (data: SeveritiesAdvancedInputSettings) => void;
}
export const SeveritiesAdvancedSettings = ({
  data,
  setData
}: SeveritiesAdvancedSettingsProps) => {
  const {
    t
  } = useTranslation("tools", {
    keyPrefix: "settings"
  });
  return <Collapse expandIconPlacement="start" className={"rounded-lg border border-subtle bg-surface *:!border-subtle [&_.ant-collapse-content]:border-t-0 [&_.ant-collapse-panel]:!border-subtle"} items={[{
    key: "advanced-settings",
    label: t("advancedAnalysisSettings"),
    classNames: {
      body: "!pt-1 !border-subtle border-t-0"
    },
    children: <div className="flex flex-col divide-y divide-gray-100 pt-2 *:py-4">
              <SwitchWithLabel id="anomalyManagementRp" label={t("anomalyManagementRp.title")} description={t("anomalyManagementRp.description")} warning={t("anomalyManagementRp.warningIfFalse")} showWarning={!data.anomalyManagementRp} checked={data.anomalyManagementRp} onChange={(checked: boolean) => {
        setData({
          ...data,
          anomalyManagementRp: checked
        });
      }} />

              <SwitchWithLabel id="defences" label={t("defences.title")} description={t("defences.description")} warning={t("defences.warningIfFalse")} showWarning={!data.defences} checked={data.defences} onChange={(checked: boolean) => {
        setData({
          ...data,
          defences: checked
        });
      }} />
            </div>
  }]} data-sentry-element="Collapse" data-sentry-component="SeveritiesAdvancedSettings" data-sentry-source-file="SeveritiesAdvancedSettings.tsx" />;
};